module.exports = __webpack_public_path__ + "images/brightlease2a5493aee0e403fd4eb0ff35e5c4d999.png";